import React, { useState, useEffect } from 'react'
import { Button, Radio, Space, Typography } from 'antd'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js/pure'
import { listCards } from '@/utils/apiEndpoints'
import { Loader, Card } from '@/components'
import CardInputForm from './CardInputForm'
import { useSelector } from 'react-redux'
import { StripeAttribution } from './StripeAttribution'

const { Text } = Typography

export const PaymentCardList = ({
  stripePaymentMethod,
  onCancel = () => {},
  onSelectCard,
  hideCancel,
  isDirectCheckout,
  showBorder,
  onCardAdd = () => {},
  showForm = false,
  cards = [],
  okButtonText = 'Authorize',
  authorizeMessage,
  isUser = true,
}) => {
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY)
  const [showCardForm, setShowCardForm] = useState(showForm)
  const [loading, setLoading] = useState(false)
  const [cardList, setCardList] = useState(cards)
  const { currentUser } = useSelector((state) => state.auth)
  const [selectedCardId, setSelectedCardId] = useState(stripePaymentMethod?.id)
  useEffect(() => {
    if (cardList?.length == 0 && showForm) {
      setShowCardForm(true)
    } else {
      setShowCardForm(false)
    }
  }, [cardList])

  const onCardAddCancel = () => {
    if (showForm) {
      onCancel()
      setShowCardForm(false)
    } else setShowCardForm(false)
  }
  const onCardAddSuccess = (cardInfo) => {
    setSelectedCardId(cardInfo.id)
    if (showForm) {
      onCardAdd()
    } else setShowCardForm(false)
    loadCards()
    if (isDirectCheckout && onSelectCard) onSelectCard && onSelectCard(cardInfo)
  }
  const onChange = async (e) => {
    setSelectedCardId(e.target.value)
  }
  const loadCards = async () => {
    try {
      setLoading(true)
      if (currentUser.stripeCustomerId) {
        const res = await listCards(currentUser.stripeCustomerId)
        if (res.result && res.result.length > 0) {
          setCardList(res.result)
        } else {
          setShowCardForm(true)
        }
      }
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }
  const onAuthorize = () => {
    const cardInfo = cardList.find((card) => card.id == selectedCardId)
    onSelectCard && onSelectCard(cardInfo)
  }

  useEffect(() => {
    if (cardList.length == 0) loadCards()
  }, [])

  return (
    <Elements stripe={stripePromise}>
      <Loader loading={loading}>
        {!loading && (
          <>
            {!showCardForm ? (
              <>
                <Space style={{ flexWrap: 'wrap' }}>
                  <Text>Choose one of your cards or</Text>
                  <Button onClick={() => setShowCardForm(true)}>
                    Add a new card
                  </Button>
                </Space>
                <Loader loading={loading} minHeight="300px">
                  {currentUser.stripeCustomerId && cardList.length > 0 && (
                    <>
                      <Radio.Group
                        onChange={onChange}
                        value={selectedCardId}
                        className="card-list"
                      >
                        {cardList.map((card) => (
                          <div
                            key={card.id}
                            className={
                              'card-details ' +
                              (showBorder ? 'card-border' : '')
                            }
                          >
                            <Radio value={card.id} key={card.id}>
                              <Card key={card.id} card={card} />
                            </Radio>
                          </div>
                        ))}
                      </Radio.Group>
                      {authorizeMessage && (
                        <div
                          className="margin-top-10"
                          style={{ marginBottom: '10px' }}
                        >
                          {authorizeMessage}
                        </div>
                      )}
                      <div style={{ display: 'flex', gap: '10px' }}>
                        {!hideCancel && (
                          <Button
                            type="ghost"
                            size="large"
                            block
                            onClick={onCancel}
                          >
                            Cancel
                          </Button>
                        )}
                        <Button
                          type="primary"
                          size="large"
                          block
                          onClick={onAuthorize}
                          disabled={!selectedCardId}
                        >
                          {okButtonText}
                        </Button>
                      </div>
                      <StripeAttribution />
                    </>
                  )}
                </Loader>
              </>
            ) : (
              <CardInputForm
                onCardAddSuccess={onCardAddSuccess}
                onCardAddCancel={onCardAddCancel}
                hideCancel={true}
                okButtonText="Save"
              />
            )}
          </>
        )}
      </Loader>
    </Elements>
  )
}
